// removed by extract-text-webpack-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-ClientSuccess-icon","text":"onfido-sdk-ui-crossDevice-ClientSuccess-text"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/ClientSuccess/style.css
// module id = 389
// module chunks = 1